import { isString, lowerCase } from 'lodash'
export default function slug(data, separator) {
  separator = separator || '-'
  if (data != null && isString(data)) {
    let slug = lowerCase(data)
    // convert to english type
    slug = slug.replace(/á|à|ả|ạ|ã|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ/gi, 'a')
    slug = slug.replace(/é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ/gi, 'e')
    slug = slug.replace(/i|í|ì|ỉ|ĩ|ị/gi, 'i')
    slug = slug.replace(/ó|ò|ỏ|õ|ọ|ô|ố|ồ|ổ|ỗ|ộ|ơ|ớ|ờ|ở|ỡ|ợ/gi, 'o')
    slug = slug.replace(/ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự/gi, 'u')
    slug = slug.replace(/ý|ỳ|ỷ|ỹ|ỵ/gi, 'y')
    slug = slug.replace(/đ/gi, 'd')
    if (isString(separator)) {
      slug = slug.replace(/[^a-zA-Z0-9]/gi, separator)
    } else {
      slug = slug.replace(/[^a-zA-Z0-9]/gi, '')
    }
    return slug
  }
  return data
}
